import React, { useState, useRef, useCallback } from 'react';
import * as htmlToImage from 'html-to-image';
// import { Download, User, CreditCard, Shield, Edit3, Mic, Heart, Users, Trash2, Plus } from 'lucide-react';
import * as FaIcons from "react-icons/fa6";
import du from '../../media/du.png';
import cvs from '../../media/cvs.jpeg';
import icssr from '../../media/icssr.svg';
import speakers from '../../data/speakers.json';

const IDCardGenerator = () => {
    const [selectedTemplate, setSelectedTemplate] = useState('speakerpost');
    const [jsonData, setJsonData] = useState(JSON.stringify([
        {
            "name": "Prof. Kumar Suresh",
            type: "speakerpost",
            guestType: "Plenary Speaker",
            "designations":[
                {
                    "designation": "Professor of Educational Administration",
                    "institution": "National Institute of Educational Planning and Administration"
                }
            ],
            "description": "Professor Kumar Suresh is Professor of Educational Administration at the National Institute of Educational Planning and Administration (NIEPA), where he has held leadership roles including Dean (Academic & Research), Director (Planning & Development), and Registrar (I/c). He has served as Honorary Professor at the Central University of Kerala and earned Sauma cum Laud (High Distinction) from the University of Fribourg, Switzerland. Actively engaged with the UGC and ICSSR as an expert on higher education policy and research, he has also collaborated with UNESCO, Hiroshima University, and other international institutions.",
            "photo": "/img/speakers/suresh.jpg"
        },
        {
            "name": "Prof. Dhananjay Singh",
            type: "speakerpost",
            guestType: "Special Guest",
            "designations":[
                {
                    "designation": "Member Secretary",
                    "institution": "ICSSR"
                },
                {
                    "designation": "Professor",
                    "department": "Centre for English Studies",
                    "institution": "Jawaharlal Nehru University"
                }
            ],
            "description": "Prof. Dhananjay Singh current member secretary of ICSSR. He teaches at the Centre for English Studies, Jawaharlal Nehru University. Prof. Singh has previously served as the Associate Dean of the School of Language, Literature and Culture Studies, JNU and Chief Proctor of JNU. Early in his teaching and research career, Prof. Singh worked, as Assistant Editor, in the prestigious project titled The Encyclopedia of Indian Poetics, with Dr. Kapil Kapoor as the Chief Editor, a project of Sahitya Akademi, New Delhi, & Union Academique Internationale (UAI), Brussels. He was also Assistant Editor, with Dr. Kapil Kapoor as the Chief Editor, of Mutual Regards: Indo-Irish Anthology, a collaborative project involving Jawaharlal Nehru University, New Delhi, and the University of Ulster at Colerain (Ireland).",
            "photo": "/img/speakers/MS-sir.png"
        },
        {
            name: "Prof. Dinesh Singh",
            type: "speaker",
            title: "Chancellor, K.R. Mangalam University",
            company: "Chancellor, K.R. Mangalam University",
            id: "AIS/CVS/DU/80910",
            email: "sarah.chen@stanford.edu",
            description: "Leading expert in AI ethics and responsible AI development",
            session: "Keynote: The Future of Ethical AI",
            photo: "/img/speakers/dinesh-singh.jpg"
        },
        {
            name: "Michael Rodriguez",
            type: "volunteer",
            role: "Registration Coordinator", 
            id: "VOL015",
            email: "m.rodriguez@aiconf.org",
            shift: "Morning Session",
            team: "Registration Team",
            phone: "+1 (555) 987-6543",
            photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=face"
        },
        {
            name: "Emma Thompson",
            type: "participant", 
            company: "TechCorp Inc.",
            position: "ML Engineer",
            id: "PAR234",
            email: "emma.t@techcorp.com",
            interests: "Computer Vision, NLP",
            experience: "3 years",
            photo: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop&crop=face"
        }
    ], null, 2));
    
    const [parsedData, setParsedData] = useState(null);
    const [jsonError, setJsonError] = useState('');
    const cardRefs = useRef({});

    const handleJsonChange = (value) => {
        setJsonData(value);
        try {
            const parsed = JSON.parse(value);
            if (Array.isArray(parsed)) {
                setParsedData(parsed);
                setJsonError('');
            } else {
                setParsedData([parsed]);
                setJsonError('');
            }
        } catch (error) {
            setJsonError('Invalid JSON format');
            setParsedData(null);
        }
    };

    // Initialize with default data
    React.useEffect(() => {
        try {
            const parsed = JSON.parse(jsonData);
            setParsedData(Array.isArray(parsed) ? parsed : [parsed]);
        } catch (error) {
            setJsonError('Invalid JSON format');
        }
    }, []);

    const domEl = useRef([]);

    const downloadImage = useCallback(async (index) => {
        // console.log('cardRefs.current:', cardRefs.current);
        const cardNode = cardRefs.current[index];
        // console.log('cardNode at index ' + index + ':', cardNode);

        if (cardNode) {
            try {
                // 2. Convert the DOM element to a data URL (PNG format)
                // const dataUrl = await htmlToImage.toPng(cardNode);
                const dataUrl = await htmlToImage.toPng(cardNode, {
                    quality: 0.95,
                    pixelRatio: 1.5,
                    useCORS: false, // Disable CORS
                    allowTaint: true, // Allow tainted canvas
                    ignoreElements: (element) => {
                        // Ignore problematic elements
                        return element.tagName === 'SCRIPT' || element.tagName === 'LINK';
                    }
                });
                // 3. Create a temporary anchor link for downloading
                const link = document.createElement('a');
                link.download = 'plenary-speaker.png'; // Set the download file name
                link.href = dataUrl;

                // 4. Programmatically click the link to trigger the download
                link.click();
            } catch (err) {
                console.error('oops, something went wrong!', err);
            }
        }
    }, []);


    const downloadAsPDF = (data, index) => {
        if (!data) return;

        const cardElement = cardRefs.current[index];
        if (!cardElement) return;

        // Create a new window for printing
        const printWindow = window.open('', '_blank');
        const cardHTML = cardElement.outerHTML;
        
        printWindow.document.write(`
        <!DOCTYPE html>
        <html>
            <head>
            <title>AI Conference ID Card - ${data.name}</title>
            <script src="https://cdn.tailwindcss.com"></script>
            <style>
                @media print {
                body { margin: 0; padding: 0px; }
                .no-print { display: none !important; }
                }
                body { font-family: system-ui, -apple-system, sans-serif; }
            </style>
            </head>
            <body>
            ${cardHTML}
            <script>
                window.onload = function() {
                window.print();
                window.onafterprint = function() {
                    window.close();
                };
                };
            </script>
            </body>
        </html>
        `);
        printWindow.document.close();
    };

    const downloadAllAsPDF = () => {
        if (!parsedData || parsedData.length === 0) return;

        const allCardsHTML = parsedData.map((data, index) => {
        const cardElement = cardRefs.current[index];
        return cardElement ? cardElement.outerHTML : '';
        }).filter(html => html).join('<div style="page-break-after: always;"></div>');

        const printWindow = window.open('', '_blank');
        
        printWindow.document.write(`
        <!DOCTYPE html>
        <html>
            <head>
            <title>AI Conference ID Cards - All</title>
            <script src="https://cdn.tailwindcss.com"></script>
            <style>
                @media print {
                body { margin: 0; padding: 0px; }
                .no-print { display: none !important; }
                }
                body { font-family: system-ui, -apple-system, sans-serif; }
            </style>
            </head>
            <body>
            ${allCardsHTML}
            <script>
                window.onload = function() {
                window.print();
                window.onafterprint = function() {
                    window.close();
                };
                };
            </script>
            </body>
        </html>
        `);
        printWindow.document.close();
    };

    const SpeakerPost = ({ data, index }) => (
    <div ref={(el) => (domEl.current[index] = el)}
    className="speakerpost w-[1123px] h-[1123px] text-white overflow-hidden relative flex flex-col border-0 border-cyan-400">
        {/* Header */}
        <div className="row align-items-center p-4 pb-0 bg-black/60">
            <div className="col-lg-2 text-lg-right">
                <img src={du} alt="" className='!inline-block h-24' />
            </div>
            <div className="col-lg-8 text-center">
                <p className='text-4xl mt-2'><strong>COLLEGE OF VOCATIONAL STUDIES</strong>
                </p>
                <p className="mt-1 text-center text-2xl">UNIVERSITY OF DELHI</p>
            </div>
            <div className="col-lg-2 text-right">
                <img src={cvs} alt="" className='!inline-block w-24 rounded-full' />
            </div>
        </div>

        <div className="text-center pt-8 pb-12 bg-gradient-to-b from-black/60 to-black/0 posts">
            <h1 className="text-5xl font-extrabold tracking-wider text-green-400 drop-shadow-md">
            National Symposium on
            <span className="block mt-2.5">
            Artificial Intelligence</span>
            </h1>

            {/* Event Details */}
            <div className="text-center mt-4">
                <p className="text-2xl font-semibold text-cyan-300">
                08<sup>th</sup> - 09<sup>th</sup> October 2025, New Delhi
                </p>
            </div>
        </div>

        {/* Profile Photo */}
        <div className="flex justify-center items-center">
            <div className="w-64 h-64 rounded-xl border-5 border-sky-600 bg-gray-200 overflow-hidden shadow-xl">
            {data.photo ? (
                <img src={data.photo} alt="Profile" className="w-full h-full object-cover" />
            ) : (
                <div className="w-full h-full flex items-center justify-center text-gray-500">
                <FaIcons.FaUser size={64} />
                </div>
            )}
            </div>

            <div className='relative h-full flex items-center text-center'>
                <div className="text-left bg-gradient-to-r from-sky-600 to-green-400 py-3 px-4 rounded-r-xl">
                    <h3 className="text-3xl font-bold text-white drop-shadow-lg">
                    {data.name || "N/A"}
                    </h3>
                    {/* <p className="text-xl text-gray-800 mt-1">{data.title || "N/A"}</p> */}
                    {data.designations && data.designations.map((designation, index) => (
                    <div key={index} className="text-sm text-gray-800 mt-1">
                      <div className="desig font-semibold mb-0">
                      {designation.designation}
                      </div>
                      <div className="insti mb-0">
                      {designation.department}
                      </div>
                      <div className="insti mb-0">
                      {designation.institution}
                      </div>
                    </div>
                  ))}

                </div>
                <div className="bg-white text-cyan-500 font-semibold text-center px-4 py-1 absolute bottom-0 right-0 inline-block rounded-md text-2xl shadow-lg">
                {data.guestType || "Plenary Speaker"}
                </div>

            </div>

        </div>

        {/* Name & Title */}

        {/* Speaker Badge */}
        <div className="flex h-[380px] items-center justify-center">
            <div className="w-[70%] p-3 bg-gradient-to-b via-cyan-800/40 from-cyan-600/60 to-cyan-600/60 text-white text-justify text-md text-shadow-lg border-1 border-cyan-600 rounded-lg shadow-xl tracking-wide">
                {data.description}
            </div>
        </div>

        {/* <div className='text-center'>
            <p className="text-xl text-gray-300 mt-14">{data.bio}</p>
        </div> */}

        {/* Footer */}
        <div className="mt-auto bg-black/80 row justify-between items-center px-10 py-3">
            <div className='col-4'>
                <p className="text-sm text-gray-400">Sponsored By</p>
                <img src={icssr} alt="" className='!inline-block h-12' />

                <p className="text-xl pl-2 font-bold text-white inline pt-4">ICSSR</p>
                {/* <p className="text-xs text-gray-400 mt-1">Digital Partner <span className='text-white font-bold'>Brey Digital</span></p> */}
            </div>
            <div className='col-4 text-center mt-2'>
                <p className="py-2 px-6 inline text-xl font-bold text-green-400 bg-white/0 border-2 border-white rounded-2xl">www.aisymposium.in<span className='text-sm text-white'><FaIcons.FaArrowUpRightFromSquare className='inline ml-2 mb-1'/></span></p>
                <p className="m-0 pt-3 text-xl font-bold text-cyan-400">
                    <span className='text-1xl text-white mr-2'><FaIcons.FaFacebook className='inline mb-1'/> <FaIcons.FaInstagram className='inline mb-1'/> <FaIcons.FaXTwitter className='inline mb-1'/> <FaIcons.FaLinkedin className='inline mb-1'/>
                    </span>@aisymposiumdu</p>
            </div>
            <div className='col-4 text-right'>
                <p className="mb-0 text-sm text-gray-400">Venue</p>
                <p className="mb-0 font-bold text-xl text-green-400">India Habitat Centre</p>
                <p className="mb-0 font-bold text-lg text-white">New Delhi</p>
            </div>
            {/* <div>
                <div className="w-24 h-24 bg-white flex items-center justify-center rounded-md text-black text-xs font-bold">
                    <img src={icssr} alt="" className='!inline-block h-16' />
                </div>
            </div> */}
        </div>
    </div>

    );

    const SpeakerTemplate = ({ data, index }) => (
    <div ref={(el) => (domEl.current[index] = el)} className="w-[794px] h-[1123px] bg-gradient-to-b from-[#0b0f1a] via-[#0f1d2e] to-[#0b0f1a] text-white rounded-xl shadow-2xl overflow-hidden relative flex flex-col border-4 border-cyan-400">
        {/* Header */}
        <div className="text-center py-10">
            <p className="text-lg text-gray-100 mb-0">College of Vocational Studies, University of Delhi</p>
        </div>

        <div className="text-center pt-16 pb-24 bg-black/40">
            <h1 className="text-5xl font-extrabold tracking-wider text-green-400 drop-shadow-md">
            National Symposium on
            <span className="block mt-2.5">
            Artificial Intelligence</span>
            </h1>

            {/* Event Details */}
            <div className="text-center mt-4">
                <p className="text-2xl font-semibold text-cyan-300">
                08<sup>th</sup> - 09<sup>th</sup> October 2025
                </p>
                <p className="text-xl text-gray-300 mt-1">New Delhi</p>
            </div>
        </div>

        {/* Profile Photo */}
        <div className="flex justify-center -mt-16">
            <div className="w-48 h-48 rounded-full border-8 border-cyan-400 bg-gray-200 overflow-hidden shadow-xl">
            {data.photo ? (
                <img src={data.photo} alt="Profile" className="w-full h-full object-cover" />
            ) : (
                <div className="w-full h-full flex items-center justify-center text-gray-500">
                <FaIcons.FaUser size={64} />
                </div>
            )}
            </div>
        </div>

        {/* Name & Title */}
        <div className="text-center mt-6">
            <h3 className="text-4xl font-bold text-green-400 drop-shadow-lg">
            {data.name || "N/A"}
            </h3>
            <p className="text-xl text-cyan-300 mt-2">{data.title || "N/A"}</p>
        </div>

        {/* Speaker Badge */}
        <div className="flex justify-center mt-10">
            <div className="w-full bg-gradient-to-r from-green-400 to-cyan-400 text-black font-bold text-center px-20 py-8 text-3xl shadow-lg uppercase tracking-wide">
            Keynote Speaker
            </div>
        </div>

        <div className='text-center'>
            <p className="text-xl text-gray-300 mt-14">ID Code: {data.id || "N/A"}</p>
        </div>

        {/* Footer */}
        <div className="mt-auto bg-black/40 flex justify-between items-center px-10 py-6">
            <div>
                <p className="text-sm text-gray-400">Sponsored By</p>
                <p className="text-lg font-bold text-green-400">ICSSR</p>
            </div>
            <div>
                <p className="mb-0 text-center text-md font-bold text-green-400"><span className='block text-sm text-gray-400'>For more, log on to:</span>www.aisymposium.in</p>
            </div>
            {/* QR code placeholder */}
            <div className="w-24 h-24 bg-white flex items-center justify-center rounded-md text-black text-xs font-bold">
            QR
            </div>
        </div>
    </div>

    );


    const SpeakTemplate = ({ data }) => (
        <div className="w-96 h-64 bg-gradient-to-br from-purple-600 via-blue-600 to-indigo-700 rounded-lg shadow-2xl text-white p-6 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-8 translate-x-8"></div>
        <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/5 rounded-full translate-y-8 -translate-x-8"></div>
        
        <div className="flex items-center justify-between mb-3 relative z-10">
            <div className="flex items-center gap-3">
            <div className="w-16 h-16 rounded-full bg-white/20 overflow-hidden border-2 border-white/30">
                {data.photo ? (
                <img src={data.photo} alt="Profile" className="w-full h-full object-cover" />
                ) : (
                <div className="w-full h-full flex items-center justify-center">
                    <FaIcons.FaUser size={24} className="text-white/70" />
                </div>
                )}
            </div>
            <div>
                <h2 className="text-xl font-bold">{data.name || 'N/A'}</h2>
                <p className="text-purple-200 text-sm">{data.title || 'N/A'}</p>
            </div>
            </div>
            <div className="bg-white/20 rounded-full p-2">
            <FaIcons.FaMicrophone size={20} />
            </div>
        </div>
        
        <div className="space-y-1 text-sm relative z-10">
            <div className="bg-white/10 rounded p-2 backdrop-blur-sm">
            <div className="flex justify-between items-center">
                <span className="text-purple-200">Speaker ID:</span>
                <span className="font-bold">{data.id || 'N/A'}</span>
            </div>
            </div>
            <div className="flex justify-between text-xs">
            <span className="text-purple-200">Company:</span>
            <span>{data.company || 'N/A'}</span>
            </div>
            {data.session && (
            <div className="text-xs">
                <span className="text-purple-200">Session: </span>
                <span>{data.session}</span>
            </div>
            )}
        </div>
        
        <div className="absolute bottom-2 right-4 text-xs text-white/50">
            AI Conference 2025
        </div>
        </div>
    );

    const VolunteerTemplate = ({ data }) => (
        <div className="w-96 h-64 bg-gradient-to-br from-green-500 to-emerald-600 rounded-lg shadow-2xl text-white p-6 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-transparent via-white/5 to-white/10 rounded-lg"></div>
        <div className="absolute top-4 right-4 w-20 h-20 bg-gradient-to-br from-yellow-400/20 to-green-400/20 rounded-full blur-xl"></div>
        
        <div className="relative z-10">
            <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-3">
                <div className="w-14 h-14 rounded-xl bg-white/20 overflow-hidden border border-white/30">
                {data.photo ? (
                    <img src={data.photo} alt="Profile" className="w-full h-full object-cover" />
                ) : (
                    <div className="w-full h-full flex items-center justify-center">
                    <FaIcons.FaUser size={20} className="text-white/70" />
                    </div>
                )}
                </div>
                <div>
                <h2 className="text-lg font-bold">{data.name || 'N/A'}</h2>
                <p className="text-green-200 text-sm">{data.role || 'Volunteer'}</p>
                </div>
            </div>
            <div className="bg-white/20 rounded-full p-2">
                <FaIcons.FaHeart size={20} />
            </div>
            </div>
            
            <div className="grid grid-cols-2 gap-3 text-xs mb-3">
            <div className="bg-white/10 rounded-lg p-3 backdrop-blur-sm">
                <div className="text-green-200">Volunteer ID</div>
                <div className="font-semibold">{data.id || 'N/A'}</div>
            </div>
            <div className="bg-white/10 rounded-lg p-3 backdrop-blur-sm">
                <div className="text-green-200">Team</div>
                <div className="font-semibold">{data.team || 'N/A'}</div>
            </div>
            </div>
            
            {data.shift && (
            <div className="bg-white/10 rounded-lg p-2 backdrop-blur-sm text-xs">
                <span className="text-green-200">Shift: </span>
                <span className="font-semibold">{data.shift}</span>
            </div>
            )}
            
            <div className="absolute bottom-2 right-4 text-xs text-white/50">
            AI Conference 2025
            </div>
        </div>
        </div>
    );

    const ParticipantTemplate = ({ data }) => (
        <div className="w-96 h-64 bg-gradient-to-br from-orange-500 to-red-500 rounded-lg shadow-2xl text-white p-6 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-8 translate-x-8"></div>
        <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/5 rounded-full translate-y-8 -translate-x-8"></div>
        
        <div className="flex items-center justify-between mb-4 relative z-10">
            <div className="flex items-center gap-3">
            <div className="w-14 h-14 rounded-xl bg-white/20 overflow-hidden border border-white/30">
                {data.photo ? (
                <img src={data.photo} alt="Profile" className="w-full h-full object-cover" />
                ) : (
                <div className="w-full h-full flex items-center justify-center">
                    <FaIcons.FaUser size={20} className="text-white/70" />
                </div>
                )}
            </div>
            <div>
                <h2 className="text-lg font-bold">{data.name || 'N/A'}</h2>
                <p className="text-orange-200 text-sm">{data.position || 'Participant'}</p>
            </div>
            </div>
            <div className="bg-white/20 rounded-full p-2">
            <FaIcons.FaUsers size={20} />
            </div>
        </div>
        
        <div className="space-y-2 text-sm relative z-10">
            <div className="flex justify-between">
            <span className="text-orange-200">ID:</span>
            <span className="font-semibold">{data.id || 'N/A'}</span>
            </div>
            <div className="flex justify-between">
            <span className="text-orange-200">Company:</span>
            <span>{data.company || 'N/A'}</span>
            </div>
            {data.interests && (
            <div className="flex justify-between">
                <span className="text-orange-200">Interests:</span>
                <span className="text-xs">{data.interests}</span>
            </div>
            )}
            {data.experience && (
            <div className="flex justify-between">
                <span className="text-orange-200">Experience:</span>
                <span>{data.experience}</span>
            </div>
            )}
        </div>
        
        <div className="absolute bottom-2 right-4 text-xs text-white/50">
            AI Conference 2025
        </div>
        </div>
    );

    const renderTemplate = (data, index) => {
        const templateType = selectedTemplate === 'auto' ? data.type : selectedTemplate;
        
        switch (templateType) {
        case 'speakerpost':
            return <SpeakerPost data={data} />;
        case 'speaker':
            return <SpeakerTemplate data={data} />;
        case 'volunteer':
            return <VolunteerTemplate data={data} />;
        case 'participant':
            return <ParticipantTemplate data={data} />;
        default:
            return <SpeakerPost data={data} />;
        }
    };

    const templates = [
        { id: 'auto', name: 'Auto (by type)', icon: FaIcons.FaCreditCard },
        { id: 'speakerpost', name: 'Speaker Post', icon: FaIcons.FaMicrophone },
        { id: 'speaker', name: 'Speaker', icon: FaIcons.FaMicrophone },
        { id: 'volunteer', name: 'Volunteer', icon: FaIcons.FaHeart },
        { id: 'participant', name: 'Participant', icon: FaIcons.FaUsers }
    ];

    const addNewEntry = () => {
        const newEntry = {
        name: "New Person",
        type: "participant",
        id: `NEW${Date.now().toString().slice(-3)}`,
        email: "new@example.com"
        };
        
        try {
        const currentData = JSON.parse(jsonData);
        const updatedData = Array.isArray(currentData) ? [...currentData, newEntry] : [currentData, newEntry];
        setJsonData(JSON.stringify(updatedData, null, 2));
        } catch (error) {
        setJsonData(JSON.stringify([newEntry], null, 2));
        }
    };

    const removeEntry = (indexToRemove) => {
        try {
        const currentData = JSON.parse(jsonData);
        if (Array.isArray(currentData) && currentData.length > 1) {
            const updatedData = currentData.filter((_, index) => index !== indexToRemove);
            setJsonData(JSON.stringify(updatedData, null, 2));
        }
        } catch (error) {
        // Handle error silently
        }
    };

      // Format JSON
    const formatJson = () => {
        try {
            const parsed = JSON.parse(jsonData);
            setJsonData(JSON.stringify(parsed, null, 2));
        } catch (error) {
            alert(`Cannot format invalid JSON: ${error.message}`);
        }
    };

    return (
    <div className="min-h-screen bg-gray-50 p-6">
        <div className="max-w-8xl mx-auto">

            <div className="grid grid-cols-1 lg:grid-cols-6 gap-8">
                {/* Left Panel - Editor */}
                <div className="col-span-2 space-y-2">
                    <div className="mb-2">
                        <h1 className="text-2xl font-bold text-gray-900 mb-2">AI Conference ID Card Generator</h1>
                        <p className="text-gray-600">Create professional identity cards for speakers, volunteers, and participants</p>
                    </div>
                    <div className="bg-white rounded-lg shadow-sm border p-3">
                        <div className="flex items-center justify-between mb-2">
                            <div className="flex items-center gap-2">
                            <FaIcons.FaPencil size={20} className="text-blue-600" />
                            <h2 className="text-lg text-black font-semibold">JSON Data Editor</h2>
                            </div>
                            <div>
                                <button 
                                    onClick={formatJson}
                                    className="px-2 py-1 mr-1 bg-indigo-500 text-white text-sm rounded-lg hover:bg-indigo-600 transition-colors"
                                >
                                Format
                                </button>
                                <button
                                onClick={addNewEntry}
                                className="px-2 py-1 bg-green-600 text-white text-sm rounded hover:bg-green-700 transition-colors"
                                >
                                <FaIcons.FaPlus className='inline' size={16} />
                                Add
                                </button>
                            </div>
                        </div>
                        <textarea
                            value={jsonData}
                            onChange={(e) => handleJsonChange(e.target.value)}
                            className="w-full h-[32rem] text-gray-700 font-mono text-sm border rounded-lg p-3 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            placeholder="Enter your JSON data here..."
                        />
                        {jsonError && (
                            <p className="text-red-500 text-sm mt-2">{jsonError}</p>
                        )}
                        {parsedData && (
                            <p className="text-green-600 text-sm mt-1">
                            {parsedData.length} entries loaded
                            </p>
                        )}
                    </div>

                    {/* Template Selector */}
                    <div className="bg-white rounded-lg shadow-sm border p-3">
                        <h3 className="text-lg font-semibold mb-2">Select Template</h3>
                        <div className="grid grid-cols-3 gap-2">
                            {templates.map((template) => {
                            const IconComponent = template.icon;
                            return (
                                <button
                                key={template.id}
                                onClick={() => setSelectedTemplate(template.id)}
                                className={`p-2 rounded-lg border-2 transition-all ${
                                    selectedTemplate === template.id
                                    ? 'border-blue-500 bg-blue-50 text-blue-700'
                                    : 'border-gray-200 hover:border-gray-300 text-gray-700'
                                }`}
                                >
                                <IconComponent size={20} className="inline mx-auto me-2" />
                                <div className="text-sm font-medium inline">{template.name}</div>
                                </button>
                            );
                            })}
                        </div>
                    </div>
                </div>

                {/* Right Panel - Preview */}
                <div className="col-span-4 space-y-6">
                    <div className="bg-white rounded-lg shadow-sm border p-6">
                        <div className="flex items-center justify-between mb-2">
                            <h2 className="text-md text-gray-600 font-semibold">
                            Preview {parsedData ? `(${parsedData.length} entries)` : ''}
                            </h2>
                            {parsedData && parsedData.length > 1 && (
                            <button
                                onClick={downloadAllAsPDF}
                                className="flex items-center gap-1 px-2 py-1 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
                            >
                                <FaIcons.FaDownload size={16} />
                                All PDFs
                            </button>
                            )}
                        </div>

                        <div className="space-y-2 max-h-[48rem] overflow-y-auto">
                            {parsedData && parsedData.length > 0 ? (
                            parsedData.map((data, index) => (
                                <div key={index} className="border rounded-lg px-4 py-2 bg-gray-50">
                                    <div className="flex items-center justify-between mb-2">
                                        <div className="flex items-center gap-2">
                                        <h3 className="font-medium text-gray-700">
                                            {data.name || 'Unnamed'} 
                                            <span className="text-sm text-gray-500 ml-2">
                                            ({data.type || 'participant'})
                                            </span>
                                        </h3>
                                        </div>
                                        <div className="flex gap-2">
                                        <button
                                            onClick={() => downloadAsPDF(data, index)}
                                            className="flex items-center gap-1 px-2 py-1 bg-blue-600 text-white text-sm rounded hover:bg-blue-700 transition-colors"
                                        >
                                            <FaIcons.FaDownload size={14} />
                                            PDF
                                        </button>
                                        <button onClick={() => downloadImage(index)}
                                        // className='btn btn-primary'
                                            className="flex items-center gap-1 px-2 py-1 bg-blue-600 text-white text-sm rounded hover:bg-blue-700 transition-colors"
                                        >
                                            <FaIcons.FaDownload size={14} />
                                            PNG
                                        </button>
                                        {parsedData.length > 1 && (
                                            <button
                                            onClick={() => removeEntry(index)}
                                            className="flex items-center gap-1 px-3 py-1 bg-red-600 text-white text-sm rounded hover:bg-red-700 transition-colors"
                                            >
                                            <FaIcons.FaTrashCan size={14} />
                                            </button>
                                        )}

                                        </div>
                                    </div>
                                    
                                    <div className="flex justify-center max-h-full">
                                        <div 
                                        ref={(el) => cardRefs.current[index] = el}
                                        className="transform scale-100 origin-top"
                                        >
                                        {renderTemplate(data, index)}
                                        </div>
                                    </div>
                                </div>
                            ))
                            ) : (
                            <div className="w-full h-64 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center text-gray-500">
                                <div className="text-center">
                                <FaIcons.FaCreditCard size={48} className="mx-auto mb-2 opacity-50" />
                                <p>Enter valid JSON data to see preview</p>
                                </div>
                            </div>
                            )}
                        </div>
                    </div>

                    {/* Sample Data */}
                    {/* <div className="bg-white rounded-lg shadow-sm border p-6">
                        <h3 className="text-lg font-semibold mb-4">Sample JSON Structure</h3>
                        <pre className="text-xs bg-gray-50 p-4 rounded border overflow-x-auto">
                            {`[
                            {
                                "name": "Dr. Sarah Chen",
                                "type": "speaker",
                                "title": "AI Ethics Researcher", 
                                "company": "Stanford University",
                                "id": "SPK001",
                                "session": "Keynote: The Future of Ethical AI",
                                "photo": "https://example.com/photo.jpg"
                            },
                            {
                                "name": "Michael Rodriguez", 
                                "type": "volunteer",
                                "role": "Registration Coordinator",
                                "id": "VOL015",
                                "team": "Registration Team",
                                "shift": "Morning Session"
                            },
                            {
                                "name": "Emma Thompson",
                                "type": "participant",
                                "company": "TechCorp Inc.",
                                "position": "ML Engineer", 
                                "id": "PAR234",
                                "interests": "Computer Vision, NLP",
                                "experience": "3 years"
                            }
                            ]`}
                        </pre>
                    </div> */}
                </div>
            </div>
        </div>
    </div>
    );
};

export default IDCardGenerator;